// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".static-legend-options .latest-axis-label{color:#9e9ead}.latest-y-axis{margin-top:16px;margin-bottom:8px}.latest-x-axis,.static-legend-height-slider{margin-bottom:16px}", ""]);
// Exports
module.exports = exports;
